module.exports = __webpack_public_path__ + "img/fr_success_1.653c421e.png";